import { colors } from '@mehilainen/mds-tokens';
import { typographyClasses } from '@mui/material';
import { pickersDayClasses } from '@mui/x-date-pickers';
import { dayCalendarClasses } from '@mui/x-date-pickers/DateCalendar';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
import { CalendarDay } from '../../../icons';
import { focusVisible } from '../shared';
const PICKER_DAY_SIZE = '36px';
export const ThemeDatepicker = {
    MuiDatePicker: {
        defaultProps: {
            // https://github.com/mui/mui-x/issues/5174#issuecomment-1153656551
            slots: { openPickerIcon: CalendarDay },
            format: 'dd.MM.yyyy',
            views: ['day'],
            reduceAnimations: true,
            slotProps: {
                desktopPaper: {
                    sx: {
                        width: 'unset',
                        '& > * > *': {
                            width: 'unset !important',
                            maxHeight: 'unset !important',
                            padding: '8px 16px 16px',
                            [`& .${dayCalendarClasses.weekDayLabel}`]: {
                                width: '40px',
                                height: '40px',
                            },
                        },
                    },
                },
            },
        },
    },
    MuiDateCalendar: {
        styleOverrides: {
            root: {
                width: 'unset',
                maxHeight: 'unset',
                [`& .${typographyClasses.caption}`]: {
                    width: PICKER_DAY_SIZE,
                    height: PICKER_DAY_SIZE,
                    margin: '4px',
                },
                '& > *': {
                    textTransform: 'capitalize',
                },
            },
        },
    },
    MuiPickersDay: {
        styleOverrides: {
            root: {
                width: PICKER_DAY_SIZE,
                height: PICKER_DAY_SIZE,
                margin: '4px',
                border: '1px solid',
                borderColor: colors.Primary500,
                borderRadius: '8px',
                backgroundColor: colors.White,
                '&:hover': {
                    backgroundColor: colors.White,
                },
                '&.Mui-disabled': {
                    backgroundColor: colors.Gray100,
                    color: colors.Gray600,
                    border: 'unset',
                },
                [`&.${pickersDayClasses.today}`]: {
                    borderColor: colors.Gray300,
                },
                '&.Mui-selected': {
                    overflow: 'hidden',
                    border: 'unset',
                    '&:after': {
                        content: '""',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        borderWidth: '16px 0 0 16px',
                        borderColor: `transparent transparent transparent ${colors.Primary300}`,
                        left: 0,
                        bottom: 0,
                        position: 'absolute',
                    },
                },
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&.Mui-focusVisible': Object.assign(Object.assign({}, focusVisible), { backgroundColor: 'unset', outlineOffset: '2px' }),
            },
            hiddenDaySpacingFiller: {
                border: 'unset',
            },
        },
    },
};
